(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-gallery-carousel-sansin"] && !Shopify.designMode) return;
  try {
    
  (function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('[data-mgc-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mgc-slide]'));
    var dotsContainer = root.querySelector('[data-mgc-dots]');
    var dots = [];
    var prevBtn = root.querySelector('[data-mgc-prev]');
    var nextBtn = root.querySelector('[data-mgc-next]');
    var lastPageCount = -1;

    // --- Dot + arrow sync on scroll ---
    var ticking = false;

    // Finds the slide closest to the track's center — used for single-slide
    // arrow stepping (independent of the page-based dot pagination below).
    function closestSlideIndex() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var r = slide.getBoundingClientRect();
        var slideCenter = r.left + r.width / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function scrollToIndex(idx) {
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      var slide = slides[idx];
      if (!slide) return;
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      var offset = (slideRect.left + slideRect.width / 2) - (trackRect.left + trackRect.width / 2);
      track.scrollBy({ left: offset, behavior: 'smooth' });
    }

    // How many slides are visible at once, based on current track/slide widths.
    function getSlidesPerView() {
      if (!slides.length) return 1;
      var gapStr = window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0';
      var gap = parseFloat(gapStr) || 0;
      var slideWidth = slides[0].getBoundingClientRect().width + gap;
      if (!slideWidth) return 1;
      var perView = Math.round(track.clientWidth / slideWidth);
      return Math.max(1, Math.min(perView, slides.length));
    }

    // Build (or rebuild) pagination dots so there's one dot per "page"
    // of visible slides, not one dot per individual slide.
    function buildDots() {
      if (!dotsContainer) return;
      var perView = getSlidesPerView();
      var pageCount = Math.max(1, Math.ceil(slides.length / perView));
      if (pageCount === lastPageCount) return;
      lastPageCount = pageCount;

      dotsContainer.innerHTML = '';
      dots = [];

      if (pageCount <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';

      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mgc-dot';
        dot.setAttribute('data-mgc-dot', '');
        dot.setAttribute('data-index', String(i));
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        (function (pageIndex) {
          dot.addEventListener('click', function () {
            scrollToPage(pageIndex);
          });
        })(i);
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }
    }

    // Which page is currently active, based on how far the track has
    // been scrolled (0 = start, 1 = fully scrolled to the end). This is
    // robust regardless of how many slides are visible per page.
    function currentPage() {
      if (!dots.length) return 0;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return 0;
      var ratio = track.scrollLeft / maxScroll;
      var page = Math.round(ratio * (dots.length - 1));
      return Math.max(0, Math.min(dots.length - 1, page));
    }

    function scrollToPage(page) {
      var pageCount = dots.length || 1;
      page = Math.max(0, Math.min(pageCount - 1, page));
      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = pageCount > 1 ? (page / (pageCount - 1)) * maxScroll : 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function updateActiveState() {
      var page = currentPage();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === page);
      });
      var idx = closestSlideIndex();
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === slides.length - 1;
      ticking = false;
    }

    track.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveState);
        ticking = true;
      }
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(closestSlideIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(closestSlideIndex() + 1);
      });
    }

    buildDots();
    updateActiveState();

    // Rebuild dots when viewport size changes the number of visible slides
    // (e.g. resizing between mobile and desktop breakpoints).
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        buildDots();
        updateActiveState();
      }, 150);
    });

    // --- Mouse drag-to-scroll (desktop) ---
    // overflow-x:auto only responds to touch swipe / trackpad / shift+wheel
    // natively. Regular left-click-drag with a mouse does nothing by default,
    // so we implement it manually here.
    var isDown = false;
    var dragStartX = 0;
    var scrollStartLeft = 0;
    var didDrag = false;

    function onPointerDown(e) {
      // Ignore drags that start on interactive elements (buttons, links, dots)
      if (e.target.closest('[data-mgc-play], [data-mgc-dot], a, button, video, iframe')) return;
      isDown = true;
      didDrag = false;
      dragStartX = e.pageX;
      scrollStartLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      // Prevent native image/text drag ghost
      e.preventDefault();
    }

    function onPointerMove(e) {
      if (!isDown) return;
      var dx = e.pageX - dragStartX;
      if (Math.abs(dx) > 3) didDrag = true;
      track.scrollLeft = scrollStartLeft - dx;
    }

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      updateActiveState();
    }

    track.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', function () {
      // Only end if button released outside; keep dragging if still down
      // (mouseup on window already handles the release case)
    });

    // Suppress accidental link/dot clicks right after a drag
    track.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    // --- Click-to-play video handling ---
    var videoFrames = root.querySelectorAll('[data-mgc-video-frame]');
    videoFrames.forEach(function (frame) {
      var playBtn = frame.querySelector('[data-mgc-play]');
      if (!playBtn) return;

      playBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var type = frame.getAttribute('data-video-type');
        var poster = frame.querySelector('.mgc-video-poster');

        if (type === 'mp4') {
          var template = frame.querySelector('[data-mgc-video-source]');
          if (!template) return;
          var fragment = template.content ? template.content.cloneNode(true) : null;
          if (poster) poster.remove();
          playBtn.remove();
          if (fragment) {
            frame.appendChild(fragment);
            var videoEl = frame.querySelector('video');
            if (videoEl) {
              videoEl.setAttribute('playsinline', '');
              videoEl.play().catch(function () {});
            }
          }
        } else if (type === 'youtube') {
          var videoId = frame.getAttribute('data-video-id');
          if (!videoId) return;
          var mute = frame.getAttribute('data-mute') === 'true' ? 1 : 0;
          var loop = frame.getAttribute('data-loop') === 'true' ? 1 : 0;
          var iframe = document.createElement('iframe');
          var src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) +
            '?autoplay=1&mute=' + mute + '&playsinline=1&rel=0' +
            (loop ? '&loop=1&playlist=' + encodeURIComponent(videoId) : '');
          iframe.setAttribute('src', src);
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('title', 'YouTube video player');
          if (poster) poster.remove();
          playBtn.remove();
          frame.appendChild(iframe);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.mgc-section').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a new section instance is added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.mgc-section');
    if (root) initGallery(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-stats-sansin"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var counters = document.querySelectorAll('[data-count-up]');
  if (!counters.length) return;

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1500;
    var startTime = null;

    // Format number with commas, preserving decimals if present in target
    var hasDecimal = (el.getAttribute('data-target') || '').indexOf('.') !== -1;

    function formatNumber(num) {
      if (hasDecimal) {
        return num.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;
      el.textContent = formatNumber(current) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = formatNumber(target) + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          if (!el.hasAttribute('data-counted')) {
            el.setAttribute('data-counted', 'true');
            animateCount(el);
          }
          obs.unobserve(el);
        }
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach(function (el) {
    observer.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();
})();
